import { usePostService } from "@libs/api-service-provider";
import type { ApiResponse } from "@libs/service-providers/api-service-provider/types";

import { LOGIN_URL } from "./apiEndpoints";
import type { LoginData, LoginPayload } from "./types";

type UsePostLoginProps = {
  onSuccess?: (response: ApiResponse<LoginData>) => void;
  onError?: (error: unknown) => void;
};

export const usePostLogin = (options: UsePostLoginProps = {}) => {
  const { onSuccess, onError } = options;

  const mutation = usePostService<LoginData, LoginPayload>({
    route: LOGIN_URL,
    onSuccess,
    onError,
  });

  return {
    ...mutation,
    isLoading: mutation.status === "pending",
    mutate: (payload: LoginPayload) => {
      mutation.mutate(payload);
    },
  };
};
